export const RegistrationTypes = {
  TEAM: "TEAM",
  EVENT: "EVENT"
};
